import { IRiskStandardEditItem, RiskStandardEditItem } from "./riskStandardEditItem";

export interface IRiskStandardEdit {
    item: IRiskStandardEditItem;
}

export class RiskStandardEdit implements IRiskStandardEdit {
    item: RiskStandardEditItem;

    constructor();
    constructor(obj: IRiskStandardEdit);
    constructor(obj?: any) {
        this.item = new RiskStandardEditItem(obj ? obj.item : null);
    }
}